const TYPES = {
  TABLE_STATE_SET: 'TABLE_STATE_SET',
  TABLE_STATE_RESET: 'TABLE_STATE_RESET',
};

export const createTableStateReducers = (
  RESOURCE_NAME: any,
  defaultTableQuery?: any,
) => ({
  /**
   * Resource table state set.
   */
  [`${RESOURCE_NAME}/${TYPES.TABLE_STATE_SET}`]: (state: any, action: any) => {
    const { queries } = action.payload;

    state.tableState = {
      ...state.tableState,
      ...queries,
    };
  },

  [`${RESOURCE_NAME}/${TYPES.TABLE_STATE_RESET}`]: (
    state: any,
    action: any,
  ) => {
    state.tableState = {
      ...defaultTableQuery,
    };
  },
});
